import React from 'react';
import './PartnerTestimonials.css'; // Import custom CSS



const PartnerTestimonials = ({heading , testimonials}) => {
  return (
    <div className="partner-testimonial-section">
      <h2 className="testimonial-heading">{heading}</h2>

      <div className="testimonial-list">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="stars">⭐️⭐️⭐️⭐️⭐️</div>
            <h4 className="testimonial-title">{testimonial.title}</h4>
            <p className="testimonial-content">{testimonial.content}</p>
            <p className="testimonial-author">— {testimonial.author}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerTestimonials;
